import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { loginWithToken } from '../../store/Auth.store';
import { Container, Logo, Text } from './styles';
import { integrateStravaAuxiliary } from '../../store/Integration.store';
import logo from '../../assets/cp-logo.png';

export default function LoginRedirect() {
  const [searchParams] = useSearchParams();
  const dispatch = useDispatch<any>();

  const token = searchParams.get('token');
  const redirectUrl = searchParams.get('redirect_url');
  const err = searchParams.get('err');
  const provider = searchParams.get('provider');
  const code = searchParams.get('code');

  useEffect(() => {
    const isStravaValid = !!code;

    if (isStravaValid) {
      integrateStravaAuxiliary(window.location.href, 'fitwards', provider)
        .then(() => {
          setTimeout(() => {
            window.location.href = 'https://corridas.velocita.com.br/onboarding?provider=cp';
          }, 2000);
        })
        .catch(() => {
          window.location.href = 'https://corridas.velocita.com.br/onboarding?provider=cp';
        });
    }
  }, [code]);

  const _loginWithToken = async () => {
    if (err) {
      window.location.href = '/login';
      return;
    }
    if (token) {
      const data = JSON.parse(atob(token.split('.')[1]));

      await dispatch(loginWithToken(data.uid, token) as any);
      if (redirectUrl) {
        window.location.href = redirectUrl;
        return;
      }

      window.location.href = '/home';
    }
  };

  useEffect(() => {
    _loginWithToken();
  }, [token]);

  return (
    <Container>
      <Logo src={logo} alt="logo" />

      {
        code ? (
          <Text>Integrando com Fitwards...</Text>
        ) : (
          <Text>{`Redirecionando para ${redirectUrl ?? 'o Corrida Perfeita'}`}</Text>
        )
      }
    </Container>
  );
}
